import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../ui/select";
import styles from "./MonthYearPicker.module.css";
import { RiArrowDropDownLine } from "react-icons/ri";

const monthOptions = [
  { value: "01", label: "Jan" },
  { value: "02", label: "Feb" },
  { value: "03", label: "Mar" },
  { value: "04", label: "Apr" },
  { value: "05", label: "May" },
  { value: "06", label: "Jun" },
  { value: "07", label: "Jul" },
  { value: "08", label: "Aug" },
  { value: "09", label: "Sep" },
  { value: "10", label: "Oct" },
  { value: "11", label: "Nov" },
  { value: "12", label: "Dec" },
];

const buildYearOptions = (startYear) => {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let year = currentYear; year >= startYear; year -= 1) {
    years.push(String(year));
  }

  return years;
};

const MonthYearPicker = ({
  value,
  onChange,
  startYear = 1900,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const hasValue = Boolean(value);
  const today = new Date();
  const currentYear = String(today.getFullYear());
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

  const [selectedYear, selectedMonth] = value
    ? value.split("-")
    : [currentYear, currentMonth];

  const years = useMemo(() => buildYearOptions(startYear), [startYear]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        !event.target.closest(`.${styles.yearSelectContent}`)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const monthLabel =
    monthOptions.find((option) => option.value === selectedMonth)?.label ||
    "Month";

  const handleMonthClick = (monthValue) => {
    const nextValue = `${selectedYear}-${monthValue}`;
    onChange?.(nextValue);
    setIsOpen(false);
  };

  const handleYearChange = (nextYear) => {
    let nextMonth = selectedMonth;
    if (nextYear === currentYear && nextMonth > currentMonth) {
      nextMonth = currentMonth;
    }

    onChange?.(`${nextYear}-${nextMonth}`);
  };

  const handleClear = (event) => {
    event.stopPropagation();
    onChange?.("");
    setIsOpen(false);
  };

  return (
    <div
      className={`${styles.wrapper} ${className}`}
      ref={wrapperRef}
    >
    <button
    type="button"
    className={styles.trigger}
    onClick={() => setIsOpen((prev) => !prev)}
    aria-expanded={isOpen}
    >
    <span className={styles.label}>
    {hasValue ? `${monthLabel} ${selectedYear}` : "Filter By Month"}
    </span>

    {hasValue && (
      <button
        type="button"
        className={styles.clearInline}
        onClick={handleClear}
      >
        Clear
      </button>
    )}

    <RiArrowDropDownLine
     className={`${styles.icon} ${isOpen ? styles.rotate : ""}`}
    />
    </button>


      {isOpen && (
        <div className={styles.panel}>
          <div className={styles.yearRow}>
            <span className={styles.label}>Year</span>
            <Select value={selectedYear} onChange={handleYearChange}>
              <SelectTrigger className={styles.yearTrigger}>
                <SelectValue>{selectedYear}</SelectValue>
              </SelectTrigger>
              <SelectContent className={styles.yearSelectContent}>
                {years.map((year) => (
                  <SelectItem key={year} value={year}>
                    {year}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className={styles.monthGrid}>
            {monthOptions.map((month) => {
              const isFutureMonth =
                selectedYear === currentYear && month.value > currentMonth;

              return (
              <button
                key={month.value}
                type="button"
                className={`${styles.monthButton} ${
                  selectedMonth === month.value ? styles.monthActive : ""
                }`}
                disabled={isFutureMonth}
                onClick={() => handleMonthClick(month.value)}
              >
                {month.label}
              </button>
              );
            })}
          </div>

        </div>
      )}
    </div>
  );
};

export default MonthYearPicker;
